import apiClient from '@u/apiClient'

let base_errors = { deceased: {}, events: [] }
export default {
  //#region store

  storeWorkTask({ commit }, obj) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .post(`api/work-task`, obj.task)
      .then((response) => response.data)
  },

  //#endregion

  //#region update

  updateWorkTask({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .put(`api/work-task/${payload.id}`, payload.task)
      .then((response) => {
        commit('updateWorkTaskInWork', response.data.workTask)
        commit('setSelectedWorkTask', response.data.workTask)
        return response.data
      })
  },

  updateWorkTaskStatus({ commit, state }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return apiClient
      .get(
        `api/work-task/update-status/${payload.id}?new_status=${payload.new_status}`
      )
      .then((response) => {
        commit('setWork', response.data.work)
        if (state.selectedWorkTask) {
          if (state.selectedWorkTask.parent_type === 'App\\Models\\Work') {
            commit(
              'setSelectedWorkTask',
              response.data.work.work_tasks.find(
                (work_task) => work_task.id === state.selectedWorkTask.id
              )
            )
          } else if (
            state.selectedWorkTask.parent_type === 'App\\Models\\Event'
          ) {
            commit(
              'setSelectedWorkTask',
              response.data.work.events
                .find((event) => event.id === state.selectedWorkTask.parent_id)
                ?.work_tasks.find(
                  (work_task) => work_task.id === state.selectedWorkTask.id
                )
            )
          }
        }
        return response.data
      })
  }

  //#endregion
}
